import { Link, useParams } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { LEGAL_DOCS, LEGAL_ORDER } from "@/content/legal";
import Icon from "@/components/shared/Icon";
import Seo from "@/components/shared/Seo";
import PageHero from "@/components/shared/PageHero";

export default function Legal() {
  const { t, lp, code } = useLang();
  const { doc } = useParams();
  const current = doc && LEGAL_DOCS[doc] ? LEGAL_DOCS[doc] : null;

  if (!current) {
    return (
      <>
        <Seo title={t("legal.title")} />
        <PageHero eyebrow="Legal" title={t("legal.title")} tone="navy" />
        <section className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
          <div className="grid gap-4 sm:grid-cols-2">
            {LEGAL_ORDER.map((key) => (
              <Link key={key} to={lp(`/legal/${key}`)} data-testid={`legal-link-${key}`} className="flex items-center justify-between rounded-2xl border-2 border-[#147DEB]/10 bg-white p-5 transition-all hover:-translate-y-1 hover:shadow-lg">
                <span className="font-display font-bold text-[#082B66]">{t(LEGAL_DOCS[key].titleKey)}</span>
                <Icon name="ArrowRight" className="h-5 w-5 text-[#147DEB]" />
              </Link>
            ))}
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      <Seo title={t(current.titleKey)} />
      <PageHero eyebrow="Legal" title={t(current.titleKey)} tone="navy" />
      <section className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <Link to={lp("/legal")} className="inline-flex items-center gap-1.5 text-sm font-bold text-[#147DEB] hover:underline" data-testid="legal-back-link">
          <Icon name="ArrowLeft" className="h-4 w-4" /> {t("legal.title")}
        </Link>
        <div className="mt-6 space-y-5 rounded-3xl border-2 border-[#147DEB]/10 bg-white p-7 sm:p-9">
          {current.body[code].map((p, i) => (
            <p key={i} className="text-base leading-relaxed text-[#334155]">{p}</p>
          ))}
        </div>
        <div className="mt-8 flex flex-wrap gap-2">
          {LEGAL_ORDER.filter((k) => k !== doc).map((k) => (
            <Link key={k} to={lp(`/legal/${k}`)} className="rounded-full bg-[#E8F5FF] px-4 py-2 text-sm font-bold text-[#147DEB] hover:bg-[#D4EDFF]">
              {t(LEGAL_DOCS[k].titleKey)}
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
